import { Drawer, Text } from "dash-ui";
import { useEffect, useRef, useState } from "react";
import { BuildingTypeFilter } from "./building-type-filter";
import { IdxEmbeddedSearchPageFilters } from "../../constants/constants";
import { Updater } from "use-immer";
import { MarketAreaFilter } from "./market-area-filter";
import { ProjectStatusFilter } from "./project-status-filter";
import { PriceRangeFilter } from "./price-range-filter";
import { PropertyTransactionTypeFilter } from "./property-transaction-type-filter";

const FilterDrawer = ({
  filters,
  mainColor,
  mainColorLight,
  textColor,
  onClose,
  setFilters,
  goToFirstPage,
}: {
  filters: IdxEmbeddedSearchPageFilters;
  mainColor: string;
  mainColorLight: string;
  textColor: string;
  isMobile?: boolean;
  onClose: () => void;
  setFilters: Updater<IdxEmbeddedSearchPageFilters>;
  goToFirstPage: () => void;
}) => {
  const prevFiltersState = useRef({ ...filters });
  const [isSearchButtonHovered, setIsSearchButtonHovered] = useState(false);

  // Blocks background scrolling when the drawer is open
  const usePreventBackgroundScroll = () => {
    useEffect(() => {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.top = `-${scrollY}px`;

      return () => {
        // Cleanup
        document.body.style.position = "";
        document.body.style.width = "";
        document.body.style.top = "";
      };
    }, []);
  };
  usePreventBackgroundScroll();

  const closeDrawer = () => {
    setFilters(prevFiltersState.current);
    onClose();
  };

  const handleSearch = () => {
    prevFiltersState.current = { ...filters };
    goToFirstPage();
    onClose();
  };

  return (
    <Drawer
      isOpen={true}
      onRequestClose={closeDrawer}
      title="Filters"
      subtitle="Filter properties by your preferences"
    >
      <div className="overflow-y-auto px-1 flex flex-1 flex-col h-[calc(100%-60px)] justify-between">
        <div>
          <div className="mt-4 mb-4">
            <PriceRangeFilter
              filters={filters}
              mainColor={mainColor}
              mainColorLight={mainColorLight}
              textColor={textColor}
              setFilters={setFilters}
              isMobile={true}
            ></PriceRangeFilter>
          </div>

          <div className="mb-4">
            <Text>Transaction Type</Text>
            <PropertyTransactionTypeFilter
              filters={filters}
              mainColor={mainColor}
              mainColorLight={mainColorLight}
              textColor={textColor}
              setFilters={setFilters}
              isMobile={true}
            ></PropertyTransactionTypeFilter>
          </div>

          <div className="mb-4">
            <Text>Market Areas</Text>
            <MarketAreaFilter
              filters={filters}
              mainColor={mainColor}
              mainColorLight={mainColorLight}
              textColor={textColor}
              setFilters={setFilters}
              isMobile={true}
            ></MarketAreaFilter>
          </div>

          <div className="mb-4">
            <Text>Building Type</Text>
            <BuildingTypeFilter
              filters={filters}
              mainColor={mainColor}
              mainColorLight={mainColorLight}
              textColor={textColor}
              setFilters={setFilters}
              isMobile={true}
            ></BuildingTypeFilter>
          </div>

          <div className="mb-4">
            <Text>Project Status</Text>
            <ProjectStatusFilter
              filters={filters}
              mainColor={mainColor}
              mainColorLight={mainColorLight}
              textColor={textColor}
              setFilters={setFilters}
              isMobile={true}
            ></ProjectStatusFilter>
          </div>
        </div>

        <div className="mt-2 border-t pt-6">
          <button
            className={`p-2 mr-4 px-4 rounded-md`}
            style={{
              color: "white",
              backgroundColor: isSearchButtonHovered
                ? `${mainColor}dd`
                : mainColor,
              minWidth: 120,
            }}
            onMouseEnter={() => setIsSearchButtonHovered(true)}
            onMouseLeave={() => setIsSearchButtonHovered(false)}
            onClick={handleSearch}
          >
            Search
          </button>
          <button
            className={`p-2 mr-4 px-4 rounded-md border hover:bg-gray-50`}
            style={{
              borderColor: mainColor,
              color: mainColor,
              minWidth: 120,
            }}
            onClick={closeDrawer}
          >
            Cancel
          </button>
        </div>
      </div>
    </Drawer>
  );
};

export default FilterDrawer;
